import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MASONRY_BREAKPOINTS } from '../../constants/templateGrid';
import { useMemo } from 'react';
import Masonry from 'react-masonry-css';
import TemplateTile from '../TemplateTile/TemplateTile';
import ResultsNotFound from './ResultsNotFound';
import TemplateListLoader from './TemplateListLoader';
const loaderSizeList = [
    'iv-pt-template-vh',
    'iv-pt-template-hh',
    'iv-pt-template',
    'iv-pt-template-hh',
    'iv-pt-template-vh',
    'iv-pt-template',
    'iv-pt-template-hh',
    'iv-pt-template-vh',
    'iv-pt-template',
];
const TemplatesPage = ({ templates, noMoreTemplates, fetchMore, showFavourite = false, onTemplateSelect, onFavouriteClick, isFetching, searchQuery = '', templateGridBreakpoints, }) => {
    const showResultsNotFound = useMemo(() => {
        return !isFetching && templates.length === 0;
    }, [isFetching, templates.length]);
    return showResultsNotFound ? (_jsx(ResultsNotFound, { resultsMessage: `Sorry, your search returned zero results ${searchQuery.length > 0 && `for "${searchQuery}"`}`, isFavourite: false, showHints: false, pageType: "template" })) : (_jsxs(Masonry, { breakpointCols: templateGridBreakpoints || MASONRY_BREAKPOINTS, className: "lihp-template-grid", columnClassName: "lihp-template-grid_column", children: [templates.map(template => (_jsx(TemplateTile, { showFavourite: showFavourite, onFavouriteClick: onFavouriteClick, onTemplateSelect: onTemplateSelect, workflow: 'marketing', template: template }, template.algoliaObjectId || template.id))), !noMoreTemplates &&
                loaderSizeList.map((size, i) => (_jsx(TemplateListLoader, { size: size, loadMoreTemplates: fetchMore }, i)))] }));
};
export default TemplatesPage;
